import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'


const _withScopeId = n => (_pushScopeId("data-v-0cb0217e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-0cb0217e><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-0cb0217e><img src=\"" + _imports_0 + "\" alt=\"\" data-v-0cb0217e><div style=\"display:flex;flex-direction:column;\" data-v-0cb0217e><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-0cb0217e>INVESTOR INQUIRIES</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Submit")

import Footer from "@/components/home/Footer.vue";
import { ref, reactive } from "vue";
import { ElMessage, FormInstance } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'Investor',
  setup(__props) {

const formRef = ref<FormInstance>();

const labelPosition = ref("left");

const formLabelAlign = reactive({
  name: "",
  tel: "",
  comments: "",
});

const submitForm = (formEl: FormInstance | undefined) => {
    console.log(formLabelAlign,999908)
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log(valid,"submit!");
    ElMessage('Comming soon...')
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          "label-position": labelPosition.value,
          "label-width": "100px",
          rules: "rules",
          model: formLabelAlign,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: " Name",
              rules: [{ required: true,message: 'Please input Name', trigger: 'blur',}],
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formLabelAlign.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formLabelAlign.name) = $event)),
                  placeholder: "Please Enter Your Name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: " Tel",
              rules: [{required: true,message: 'Please input Tel',trigger: 'blur',}],
              prop: "tel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formLabelAlign.tel,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formLabelAlign.tel) = $event)),
                  placeholder: "Please Enter Your Tel"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: " Comments",
              rules: [{required: true, message: 'Please input Comments',trigger: 'blur',}],
              prop: "comments"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formLabelAlign.comments,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formLabelAlign.comments) = $event)),
                  placeholder: "Please Enter Your Comments"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(formRef.value)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "model"])
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})